import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const MineralStats = ({
  img,
  subheading,
  heading1,
  desc1,
  heading2,
  desc2,
  stats,
  images=[],
}) => {

  const {
    ref: statsRef,
    inView: statsInView
  } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

    const getText = (node) => {
    if (typeof node === "string") return node;
  
    if (Array.isArray(node))
      return node.map(getText).join("");
  
    if (React.isValidElement(node))
      return getText(node.props.children);
  
    return "";
  };

  return (
    <>
      <section className="who-section bentonite-page">

        <div className="container">

          {/* LEFT IMAGE */}

        <motion.div className="who-image-wrapper">

  {images.length > 0 ? (

    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      loop
      autoplay={{
        delay: 5500,
        disableOnInteraction: false,
      }}
      className="who-slider"
    >
      {images.map((item, index) => (
        <SwiperSlide key={index}>
          <motion.img
            src={item.img}
            alt={`${getText(heading1)} ${index + 1} | Iris Impulse India Pvt. Ltd.`}
            className="who-image"
          />
        </SwiperSlide>
      ))}
    </Swiper>

  ) : (

    <motion.img
      src={img}
      alt={`${heading1} | Iris Impulse India Pvt. Ltd.`}
      className="who-image"
    />

  )}

</motion.div>

          {/* RIGHT CONTENT CARD */}

          <motion.div
            className="mining-card"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2
            }}
          >

            {/* OPTIONAL SUBHEADING */}
              <div className="mining-card-inner">
            {subheading && (

              <motion.h3
                className="section-subheading"
                variants={fadeUp}
              >
                {subheading}
              </motion.h3>

            )}

            {/* HEADING 1 */}

            <motion.h2
              className="section-heading"
              variants={fadeUp}
            >
              {heading1}
            </motion.h2>

            {/* DESC 1 */}

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {desc1}
            </motion.p>

            {/* HEADING 2 */}

            {heading2 && (

              <motion.h2
                className="section-heading"
                variants={fadeUp}
              >
                {heading2}
              </motion.h2>

            )}

            {/* DESC 2 */}

            {desc2 && (

              <motion.p
                className="section-text"
                variants={fadeUp}
              >
                {desc2}
              </motion.p>

            )}

            {/* STATS */}

            <motion.div
              className="who-stats"
              ref={statsRef}
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.3
              }}
            >

              {stats.map((item, i) => (

                <motion.div
                  key={i}
                  className="who-stat"
                  variants={fadeUp}
                >

                  <h3>
                    {statsInView && (
                      <CountUp
                        end={item.number}
                        duration={3}
                      />
                    )}
                    {item.suffix}
                  </h3>

                  <p className="section-text">
                    {item.text}
                  </p>

                </motion.div>

              ))}

            </motion.div>
</div>
          </motion.div>

        </div>

      </section>
    </>
  );
};

export default MineralStats;